var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCompairIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 20,
  viewBox: "0 0 18 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.0503 10L18 14.9498L13.0503 19.8995L11.636 18.4853L14.172 15.949L1 15.9498V13.9498L14.172 13.949L11.636 11.4142L13.0503 10ZM4.94975 0L6.36396 1.41422L3.828 3.949L17 3.94975V5.94975L3.828 5.949L6.36396 8.4853L4.94975 9.8995L0 4.94975L4.94975 0Z",
  fill: "#D44500"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCompairIcon);
export { ForwardRef as ReactComponent };